/**
 * BoardPacket — PDF preview/export stub.
 * TODO Wave 3: Wire to PLANNED `/v3/audit-reports/board-packet` endpoint.
 * Today: renders a pre-flight checklist of the sections that will ship in
 * the packet so an exec can confirm before export.
 */

import { Button, Pill } from '@/components/primitives';
import type { RrmPeriod } from '../types';

export interface BoardPacketProps {
  period: RrmPeriod;
  onExport: () => void;
}

const SECTIONS: ReadonlyArray<string> = [
  'Cover + executive summary (auto-generated)',
  'Volume: Accounts Opened / Deposit Balance / New Customers / Revenue',
  'Velocity: pipeline throughput, stage SLAs',
  'Mix: product + branch heat map',
  'Channel: RCP vs walk-in vs kiosk',
  'Quality: compliance exceptions + QC',
  'Customer: retention, NPS proxies',
  'Operational: SLA compliance, staff utilization',
  'Financial: fee income, NII, cost-to-open',
  'Innovation highlights (if Executive or Innovation-Officer)',
];

export function BoardPacket({ period, onExport }: BoardPacketProps): JSX.Element {
  return (
    <section className="rrm-chart-card" aria-labelledby="rrm-packet-h">
      <div className="rrm-chart-header">
        <div>
          <div className="rrm-chart-title" id="rrm-packet-h">Board packet export</div>
          <div className="rrm-chart-sub">10 sections · period = {period}</div>
        </div>
        <Button variant="green" size="sm" onClick={onExport}>📦 Export packet</Button>
      </div>
      <div className="rrm-chart-body">
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {SECTIONS.map((s) => (
            <li key={s} style={{ padding: 'var(--sp-3) 0', borderBottom: '1px dashed var(--ink-100)', display: 'flex', gap: 'var(--sp-5)', alignItems: 'center' }}>
              <Pill variant="ok">Ready</Pill>
              <span style={{ fontSize: 13, color: 'var(--ink-700)' }}>{s}</span>
            </li>
          ))}
        </ul>
        <p style={{ marginTop: 'var(--sp-7)', fontSize: 12, color: 'var(--ink-500)' }}>
          PDF rendering ships Wave 3 — backed by PLANNED <code>/v3/audit-reports/board-packet</code>.
        </p>
      </div>
    </section>
  );
}
